<template>
    <header class="relative z-10 flex-shrink-0 flex h-16 bg-white border-b border-gray-200 lg:border-none shadow-sm">
        <button class="px-4 border-r border-gray-200 text-gray-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cyan-500 lg:hidden" @click="handleOpenMenu">
            <span class="sr-only">Open sidebar</span>
            <svg-vue icon="bars" class="icon -md"></svg-vue>
        </button>

        <div class="flex-1 flex justify-between px-4 sm:px-6">
            <div class="flex flex-1 items-center">

            </div>
            <div class="ml-4 flex items-center md:ml-6">
                <div class="ml-3 relative flex flex-row">
                    <div>
                        <button @click.prevent="handleDropdownOpen('settings')" class="mr-3 bg-white rounded-full flex items-center text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500"
                                id="user-menu" aria-haspopup="true">
                            <img class="h-8 w-8 rounded-full cursor-pointer" src="https://cdn.iconscout.com/icon/free/png-256/avatar-370-456322.png" alt="">
                        </button>
                    </div>

                    <div>
                        <button @click="handleDropdownOpen('create')"
                                class="bg-custom-600 p-1 rounded-full flex items-center text-sm hover:bg-cyan-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500"
                                id="create-menu" aria-haspopup="true">
                            <svg-vue icon="plus" class="text-white fill-current h-6 w-6"></svg-vue>
                        </button>
                    </div>

                    <div v-if="is_dropdown_open === 'settings'" v-click-away="handleDropdownClose" class="origin-top-right absolute top-8 right-9 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5" role="menu" aria-orientation="vertical" aria-labelledby="user-menu">
                        <p class="px-4 py-2 text-sm">Logged as <span class="font-bold">{{ auth_user.name }}</span></p>
                        <a href="#" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" role="menuitem" @click.prevent="handleLogout">Logout</a>
                    </div>

                    <div v-if="is_dropdown_open === 'create'" v-click-away="handleDropdownClose" class="origin-top-right absolute top-8 right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5" role="menu" aria-orientation="vertical" aria-labelledby="user-menu">

                    </div>
                </div>
            </div>
            <p>

            </p>

        </div>
    </header>
</template>

<script>
import { directive } from "vue3-click-away";

import Input from "../form/input"

export default {
    data() {
        return {
            is_dropdown_open: null,
        }
    },
    computed: {
        auth_user() {
            return this.$store.state.auth.auth_user;
        }
    },
    methods: {
        handleDropdownOpen(name) {
            this.is_dropdown_open = name;
        },
        handleDropdownClose() {
            this.is_dropdown_open = null;
        },
        handleLogout() {
            return this.$emit('logout');
        },
        handleOpenMenu() {
            return this.$emit('openMenu');
        },
    },
    components: {
        Input,
    },
    directives: {
        ClickAway: directive
    }
}
</script>
